<script>
import BaseButton from '~/components/common/Button/BaseButton';

export default {
    name: 'DropDownItem',
    components: {
        BaseButton,
    },
    props: {
        wrapper: {
            type: String,
            default: 'li',
        },
        contentWrapper: {
            type: String,
            default: 'section',
        },
    },
    data() {
        return {
            visibleState: false,
        };
    },
    render(h) {
        const { default: slotDefault, content: slotContent } = this.$slots;
        const baseButtonElement = h(BaseButton, {
            nativeOn: {
                click: () => {
                    this.visibleState = !this.visibleState;
                    this.$emit('toggleVisibleState', { state: this.visibleState });
                },
            },
        }, [slotDefault]);

        const contentElement = h(this.contentWrapper, {
            directives: [
                {
                    name: 'show',
                    value: this.visibleState,
                },
            ],
        }, [slotContent]);

        return h(this.wrapper, {
            class: {
                active: this.visibleState,
            },
        }, [
            baseButtonElement,
            contentElement,
        ]);
    },
};
</script>
